import { render } from "./serviceRequestEmail.vue?vue&type=template&id=81f49c6c&scoped=true"
import script from "./serviceRequestEmail.vue?vue&type=script&lang=js"
export * from "./serviceRequestEmail.vue?vue&type=script&lang=js"

import "./serviceRequestEmail.vue?vue&type=style&index=0&id=81f49c6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f49c6c"]])

export default __exports__